import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  getEventLocationsApi,
  createEventLocationApi,
  deleteEventLocationApi,
  updateEventLocationApi,
  toggleEventLocationStatusApi,
  createEventLocationTypeApi,
  updateEventLocationTypeApi,
  getEventLocationTypesApi,
} from "./eventLocationApi";

export const getEventLocations = createAsyncThunk(
  "eventLocation/getEventLocations",
  async (params, thunkAPI) => {
    try {
      const res = await getEventLocationsApi(params);
      return res.data.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response?.data);
    }
  }
);

export const createEventLocation = createAsyncThunk(
  "eventLocation/createEventLocation",
  async (data, thunkAPI) => {
    try {
      const res = await createEventLocationApi(data);
      return res.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response?.data);
    }
  }
);

export const deleteEventLocation = createAsyncThunk(
  "eventLocation/deleteEventLocation",
  async (id, thunkAPI) => {
    try {
      await deleteEventLocationApi(id);
      return id;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response?.data);
    }
  }
);

export const updateEventLocation = createAsyncThunk(
  "eventLocation/updateEventLocation",
  async ({ id, data }, thunkAPI) => {
    try {
      const res = await updateEventLocationApi(id, data);
      return res.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response?.data);
    }
  }
);

export const toggleEventLocationStatus = createAsyncThunk(
  "eventLocation/toggleEventLocationStatus",
  async (locationId, thunkAPI) => {
    try {
      const res = await toggleEventLocationStatusApi(locationId);
      return res.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response?.data);
    }
  }
);

export const createEventLocationType = createAsyncThunk(
  "eventLocation/createEventLocationType",
  async (data, thunkAPI) => {
    try {
      const res = await createEventLocationTypeApi(data);
      return res.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response?.data);
    }
  }
);

export const updateEventLocationType = createAsyncThunk(
  "eventLocation/updateEventLocationType",
  async ({ eventTypeId, data }, thunkAPI) => {
    try {
      const res = await updateEventLocationTypeApi(eventTypeId, data);
      return res.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response?.data);
    }
  }
);

export const getEventLocationTypes = createAsyncThunk(
  "eventLocation/getEventLocationTypes",
  async ({ page = 1, limit = 10, search = "", locationId = "" }, thunkAPI) => {
    try {
      const res = await getEventLocationTypesApi({
        page,
        limit,
        search,
        locationId,
      });
      return res.data.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response?.data);
    }
  }
);

const eventLocationSlice = createSlice({
  name: "eventLocation",
  initialState: {
    locations: [],
    locationTypes: [],
    loading: false,
    error: null,
    total: 0,
    page: 1,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getEventLocations.pending, (state) => {
        state.loading = true;
      })
      .addCase(getEventLocations.fulfilled, (state, action) => {
        state.loading = false;

        state.locations = action.payload || [];
        state.total = action.payload.total || 0;
        state.page = action.payload.page || 1;
      })
      .addCase(getEventLocations.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(createEventLocation.fulfilled, (state, action) => {
        if (action.payload?.data) {
          state.locations.unshift(action.payload.data);
        }
      })

      .addCase(deleteEventLocation.fulfilled, (state, action) => {
        state.locations = state.locations.filter(
          (item) => item.id !== action.payload
        );
      })
      .addCase(getEventLocationTypes.fulfilled, (state, action) => {
        state.locationTypes = action.payload.items || [];
        state.total = action.payload.total || 0;
      })

      .addCase(updateEventLocation.fulfilled, (state, action) => {
        const updated = action.payload?.data;
        if (!updated) return;

        const index = state.locations.findIndex((item) => item.id === updated.id);
        if (index !== -1) {
          state.locations[index] = updated;
        }
      })
      .addCase(toggleEventLocationStatus.fulfilled, (state, action) => {
        const updated = action.payload?.data;
        if (!updated) return;

        const index = state.locations.findIndex((item) => item.id === updated.id);
        if (index !== -1) {
          state.locations[index] = updated;
        }
      });
  },
});

export default eventLocationSlice.reducer;
